import { useState, useEffect } from 'react';
import axios from 'axios';

const API =  process.env.REACT_APP_API_URL;

export default function AdminSEO() {
  const [products, setProducts] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/admin/products`).then(res => setProducts(res.data));
  }, []);

  const startEdit = (product) => {
    setEditingId(product.id);
    setMetaTitle(product.metaTitle || '');
    setMetaDescription(product.metaDescription || '');
  };

  const handleSave = async (id) => {
    await axios.put(`${API}/api/admin/products/${id}`, { metaTitle, metaDescription });
    setEditingId(null);
    // refresh list
    axios.get(`${API}/api/admin/products`).then(res => setProducts(res.data));
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">SEO Settings</h2>
      <ul className="space-y-2">
        {products.map(p => (
          <li key={p.id} className="border p-2 flex justify-between items-center">
            <span>{p.name}</span>
            <button onClick={() => startEdit(p)} className="text-blue-500">Edit SEO</button>
            {editingId === p.id && (
              <div className="flex gap-2 mt-2">
                <input placeholder="Meta Title" className="border p-1" value={metaTitle} onChange={e => setMetaTitle(e.target.value)} />
                <input placeholder="Meta Description" className="border p-1" value={metaDescription} onChange={e => setMetaDescription(e.target.value)} />
                <button onClick={() => handleSave(p.id)} className="bg-black text-white px-2 py-1">Save</button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}